// extracted by mini-css-extract-plugin
export var paginationContainer = "_57-0";